import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/';

import './plugins/bootstrap';
import './plugins/swiper';

import ApiService from '@/common/api.service';

import BASE_URL from '@/common/config';

ApiService.init();

Vue.config.productionTip = false;

Vue.prototype.baseUrl = BASE_URL;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
